<template>
  <div>
    <KTCodePreview v-bind:title="'Cập nhật quyền'">
      <template v-slot:preview>
        <LoadingSpinner
          v-if="isLoadingComponent"
          :message="'Đang tải dữ liệu quyền...'"
        />
        <v-form v-else ref="form" lazy-validation>
          <div class="col-md-12 mb-5">
            <div class="row">
              <div class="col-md-3">
                <b-row class="my-1">
                  <label class="label-input">Mã quyền:</label>
                  <span class="text-danger">*</span>
                </b-row>
                <b-row class="my-1">
                  <b-input
                    size="sm"
                    placeholder="Nhập mã quyền"
                    v-model="$v.form.code.$model"
                    :state="validateState('code')"
                    append-icon="search"
                    single-line
                    hide-details
                    :disabled="!!roleId || isLoadingComponent"
                    class="col-md-12 form-control-sm"
                    aria-describedby="input-live-help input-live-feedback"
                  ></b-input>
                  <b-form-invalid-feedback id="input-live-feedback"
                    >Nhập mã với ít nhất 3 ký tự!</b-form-invalid-feedback
                  >
                </b-row>
              </div>
              <div class="col-md-3">
                <b-row class="my-1">
                  <b-col>
                    <label class="label-input">Tên quyền:</label>
                    <span class="text-danger">*</span>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col>
                    <b-input
                      placeholder="Nhập tên quyền"
                      append-icon="search"
                      single-line
                      hide-details
                      class="col-md-12 form-control-sm"
                      v-model="$v.form.name.$model"
                      :state="validateState('name')"
                      :disabled="isLoadingComponent"
                      aria-describedby="input-live-help input-name-feedback"
                    ></b-input>
                    <b-form-invalid-feedback id="input-name-feedback">
                      Nhập tên với ít nhất 3 ký tự!
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <PermissionMatrix
              :initial-permissions="listUserPermission"
              :validate-on-change="true"
              :show-description="true"
              @permission-change="handlePermissionChange"
              @validation-error="handleError"
              ref="permissionMatrix"
            />
          </div>
        </v-form>
      </template>
      <template v-slot:foot>
        <b-button
          style="fontweight: 600; width: 70px"
          variant="primary"
          size="sm"
          type="submit"
          :disabled="isBusy"
          @click="onSubmit"
          >Lưu
          <Spinner :show="isBusy" custom-class="ml-2" />
        </b-button>
        <router-link :to="'/permissions'">
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            :disabled="isBusy"
            >Hủy</b-button
          >
        </router-link>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';
import ApiService from '@/core/services/api.service';
import PermissionMatrix from '@/view/components/permissions/PermissionMatrix.vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import { handleError, makeToastSuccess } from '@/utils/common';
import { showConfirmNotify } from '@/utils/sweet-alert2';
import Spinner from '@/view/base/design-system/molecules/Spinner.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [validationMixin],
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  components: {
    KTCodePreview,
    PermissionMatrix,
    LoadingSpinner,
    Spinner,
  },
  computed: {
    nameState() {
      return this.name.length > 2;
    },
    ...mapGetters('permissionMatrix', ['getLegacyPermissions']),
  },
  data() {
    return {
      roleId: null,
      form: {
        code: '',
        name: '',
      },
      listUserPermission: [],
      isLoadingComponent: false,
      isBusy: false,
    };
  },
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(3),
      },
      name: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    this.roleId = this.$route.query.id || this.$props.id;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Quản lý quyền', route: '/permissions' },
      { title: 'Cập nhật quyền' },
    ]);
    if (this.roleId) {
      this.getRoleById();
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async getRoleById() {
      try {
        this.isLoadingComponent = true;
        const { data } = await ApiService.get(`v1/roles/${this.roleId}`);
        this.form.code = data.data.code;
        this.form.name = data.data.name;
        this.listUserPermission = data.data.permissions || [];

        this.$nextTick(() => {
          if (this.$refs.permissionMatrix) {
            this.$refs.permissionMatrix.loadPermissions(
              this.listUserPermission,
            );
          }
        });
      } catch (error) {
        handleError(error);
      } finally {
        this.isLoadingComponent = false;
      }
    },
    async onSubmit() {
      const { isConfirmed } = await showConfirmNotify({
        title: `Bạn có chắc muốn lưu thay đổi quyền '${this.form.code}'`,
        text: 'Lưu ý! thao tác làm ảnh hưởng tất cả nhân sự đang sử dụng quyền này',
      });
      if (!isConfirmed) {
        return;
      }
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      try {
        this.isBusy = true;
        const code = this.$v.form.code.$model;
        const name = this.$v.form.name.$model;

        // Get permissions from Vuex store (V2 approach)
        const permissions =
          this.getLegacyPermissions || this.listUserPermission;

        const data = {
          id: this.roleId,
          code: code,
          name: name,
          permissions: permissions,
        };

        const cmdMethod = this.roleId ? 'put' : 'post';
        const { data: response } = await ApiService[cmdMethod](
          'v1/roles',
          data,
        );
        makeToastSuccess(response.message);
        this.$router.push('/permissions');
      } catch (error) {
        handleError(error);
      } finally {
        this.isBusy = false;
      }
    },
    handlePermissionChange() {
      this.listUserPermission = this.getLegacyPermissions || [];
    },
    handleError,
  },
};
</script>
<style>
.center-label label {
  margin-bottom: 0px;
}

.label-input {
  font-weight: 500;
}
</style>
